const KEY = "ref-code";
const VALID = /^[A-Za-z0-9]{4,16}$/;

/** Запоминает код из ссылки ?ref=..., чтобы он дожил до регистрации. */
export function captureRefFromUrl(search: string) {
  const code = new URLSearchParams(search).get("ref")?.trim();
  if (!code || !VALID.test(code)) return;
  try {
    localStorage.setItem(KEY, code.toUpperCase());
  } catch {
    /* приватный режим: приглашение просто не сохранится */
  }
}

export function storedRef(): string {
  try {
    return localStorage.getItem(KEY) || "";
  } catch {
    return "";
  }
}

export function clearStoredRef() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* не критично */
  }
}

export const referralLink = (code: string) => `${window.location.origin}/register?ref=${encodeURIComponent(code)}`;

/** Курс баллов совпадает с backend (referral_mvp.go): 10 баллов = 1%, потолок 20%. */
export const REF_POINTS_PER_PERCENT = 10;
export const REF_MAX_PERCENT = 20;
export const REF_MAX_POINTS = REF_POINTS_PER_PERCENT * REF_MAX_PERCENT;
